import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useApp } from "../../contexts/AppContext";
import { useTheme } from "../../contexts/ThemeContext";

export const Header = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const { currentUser, isAdmin } = useApp();
  const { isDark, toggleTheme } = useTheme();
  const [showMenu, setShowMenu] = useState(false);

  return (
    <header className="h-[60px] bg-light-bg-secondary dark:bg-blue-50 border-b border-light-border dark:border-gray-200 flex items-center px-6 justify-between shrink-0 gap-4">
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuClick}
          className="bg-transparent border-none text-light-text-secondary dark:text-gray-700 cursor-pointer p-1.5 rounded-lg text-lg leading-none hover:bg-light-bg-tertiary dark:hover:bg-white transition"
        >
          ☰
        </button>
        <div className="h-5 w-px bg-light-border dark:bg-gray-100" />
        <button
          onClick={() => navigate("/request")}
          className="flex items-center gap-1.5 px-3.5 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg cursor-pointer text-sm font-bold transition-colors"
        >
          + New Contract Request
        </button>
      </div>

      <div className="flex items-center gap-3 relative">
        <button
          onClick={toggleTheme}
          className="p-1.5 rounded-lg text-light-text-secondary dark:text-gray-700 hover:bg-light-bg-tertiary dark:hover:bg-gray-100 transition-colors"
          title={isDark ? "Switch to light mode" : "Switch to dark mode"}
        >
          {isDark ? "☀️" : "🌙"}
        </button>

        <div className="h-5 w-px bg-light-border dark:bg-gray-100" />

        <div className="text-sm text-light-text-secondary dark:text-gray-700 text-right mr-1">
          <div className="text-light-text dark:text-gray-900 font-medium">{currentUser?.displayName}</div>
          {isAdmin && <div className="text-blue-600 text-sm font-medium">Administrator</div>}
        </div>

        <div
          onClick={() => setShowMenu(!showMenu)}
          className="w-9 h-9 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center text-white font-bold text-sm cursor-pointer hover:from-blue-500 hover:to-blue-700 transition"
        >
          {currentUser?.displayName?.[0] || "U"}
        </div>

        {showMenu && (
          <div className="absolute top-14 right-0 bg-light-bg-secondary dark:bg-white border border-light-border dark:border-gray-200 rounded-lg p-2 min-w-[180px] shadow-xl z-50">
            <div className="px-3 py-2 border-b border-light-border dark:border-gray-200 mb-1">
              <div className="text-sm text-light-text dark:text-gray-900 font-medium">{currentUser?.displayName}</div>
              <div className="text-sm text-light-text-secondary dark:text-gray-700">{currentUser?.mail}</div>
            </div>
            <button
              onClick={() => {
                setShowMenu(false);
                instance.logoutPopup();
              }}
              className="w-full px-3 py-2 bg-transparent border-none text-light-text-secondary dark:text-gray-700 cursor-pointer text-sm text-left rounded-lg hover:bg-light-bg-tertiary dark:hover:bg-gray-100 transition"
            >
              Sign Out
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
